import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { LOCALE_ID } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MessageService } from 'primeng/api';
import { MyPreset } from './core/config/theme/theme-preset';
import { environment } from '../environments/environment';
import { APP_CONFIG } from './core/config/environment.token';
import { authInterceptor } from './core/interceptors/auth-functional.interceptor';
import { publicFlowErrorsInterceptor } from './core/interceptors/public-flow-errors.interceptor';
import { SPANISH_LOCALE } from './core/config/locale/locale-spanish';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),

    provideHttpClient(
      withInterceptors([authInterceptor, publicFlowErrorsInterceptor])
    ),

    provideAnimationsAsync(),

    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),

    { provide: APP_CONFIG, useValue: environment },
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [Sentry.TraceService], multi: true },

    providePrimeNG({
        theme: {
            preset: MyPreset,
            options: {
                darkModeSelector: '.my-app-dark'
            }
        },
        translation: SPANISH_LOCALE
    }),
    MessageService
  ]
};
